var _circle, _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgHardwareinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#F1F1F9"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#hardware_inline_svg__clip0)",
    fill: "#0F0449"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.232 19.083H9.917a.917.917 0 000 1.833h1.315a.917.917 0 100-1.833zM11.232 23.667H9.917a.917.917 0 000 1.833h1.315a.917.917 0 000-1.833zM11.232 14.958H9.917a.917.917 0 000 1.833h1.315a.917.917 0 100-1.833zM30.084 19.083h-1.316a.917.917 0 000 1.833h1.316a.917.917 0 100-1.833zM28.768 16.791h1.316a.917.917 0 100-1.833h-1.316a.917.917 0 000 1.833zM30.084 23.667h-1.316a.917.917 0 000 1.833h1.316a.917.917 0 100-1.833zM20 12.149a.916.916 0 00.917-.917V9.917a.917.917 0 00-1.833 0v1.315a.917.917 0 00.917.917zM15.876 12.149a.916.916 0 00.916-.917V9.917a.917.917 0 00-1.833 0v1.315a.917.917 0 00.917.917zM24.126 12.149a.916.916 0 00.916-.917V9.917a.917.917 0 00-1.833 0v1.315a.917.917 0 00.917.917zM20 27.852a.917.917 0 00-.916.917v1.315a.917.917 0 001.833 0v-1.315a.917.917 0 00-.916-.916zM24.126 27.852a.917.917 0 00-.917.917v1.315a.917.917 0 001.833 0v-1.315a.917.917 0 00-.916-.916zM15.876 27.852a.917.917 0 00-.917.917v1.315a.917.917 0 001.833 0v-1.315a.917.917 0 00-.916-.916zM25.561 13.125H14.44a1.315 1.315 0 00-1.314 1.315V25.56a1.317 1.317 0 001.314 1.314H25.56a1.317 1.317 0 001.314-1.314V14.44a1.315 1.315 0 00-1.314-1.315zm-1.436 10.083a.917.917 0 01-.917.917h-2.291a.917.917 0 010-1.833h2.291a.916.916 0 01.917.916z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "hardware_inline_svg__clip0"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(9 9)",
    d: "M0 0h22v22H0z"
  })))));
}

export default SvgHardwareinline;